import type {
  RefreshTokenRequest,
  RefreshTokenResponse,
  SuccessLoginResponse,
} from '@/domain/auth';
import { apiClient } from '@/services/apiClient';
import { setAccessToken, setRefreshToken } from '@/utils/authority';
import { api } from '@/utils/configuration';
import { crudService } from '@/utils/request';

export const AuthService = {
  msLogin: async (azureToken: string) => {
    const response = await apiClient.post<SuccessLoginResponse>(
      `${api.AUTH}/sso/azure`,
      azureToken,
      {
        headers: { 'content-type': 'text/plain' },
      },
    );
    return response.data;
  },

  msSignUp: async (azureToken: string) => {
    const response = await apiClient.post<SuccessLoginResponse>(
      `${api.AUTH}/signup/azure`,
      azureToken,
      {
        headers: { 'content-type': 'text/plain' },
      },
    );
    return response.data;
  },

  getAzureClientId: async (email: string) => {
    const response = await apiClient.get<string>(`${api.AUTH}/sso/azure`, {
      headers: { 'content-type': 'text/plain' },
      params: { email },
    });
    return response.data;
  },

  refreshToken: (refreshTokenRequest: RefreshTokenRequest) =>
    crudService
      .post<RefreshTokenResponse>(refreshTokenRequest, `${api.AUTH}/refresh`)
      .then((response) => {
        setAccessToken(response.accessToken);
        setRefreshToken(response.refreshToken);
        return response;
      }),
};
